const lessonData = {

  2: {
    checkpoint: false,
    last: false,
    checkpoints: [],
    images: [
      {
        alt: "Diana Hendel, CEO of Long Beach Memorial Hospital (2009 - 2015) ",
        image:
          "https://chaplaincy-innovation-lab-lessons.s3.us-east-1.amazonaws.com/2025-01/dianahendel.jpg",
        order: 0,
      },
    ],
    layoutNumber: 1,
    navigation: [
      { available_scene: "4", current_scene: "2", previous_scene: "1",text: "Continue" },
    ],
    scene_number: "2",
    sidebar: false,
    sidebarImages: [],
    sidebarVideos: [],
    sidebarText: [],
    text: [
      `<p>April 16, 2009 was a day not just to be remembered but to be re-lived. 
It started like a typical early spring day in southern California for Diana Hendel, the new CEO of Long Beach Memorial Hospital.</p><p>She grew up in this institution from early days as a pharmacy student to leadership positions in the Department of Pharmacy to being appointed as the CEO in early 2009.</p><p>One of two large not for profit teaching hospitals in Long Beach in 2009, Memorial's 54 acre campus was one of the busiest on the west coast at the time with 6000 employees, 1500 independent physicians and specialists and close to $1 billion in annual revenues. 
</p>`,
    ],
    title: null,
    videos: [],
    audio: [],
  },
  
  4: {
    checkpoint: false,
    last: false,
    checkpoints: [], 
    images: [
    ],
    layoutNumber: 4,
    navigation: [
      { available_scene: "5", current_scene: "4", previous_scene: "2",text: "Continue" },
    ],
    scene_number: "4",
    sidebar: false,
    sidebarImages: [],
    sidebarVideos: [],
    sidebarText: [],
    text: [
      `<p>Dr. Hendel knew the campus and its people deeply and often did morning rounds greeting and speaking to many. On April 16, her rounds were not rushed. Dr. Henel talked with employees before heading back to her office to start her scheduled meetings. She was just a few steps from her office when she heard unusual commotion and a colleague rushed forward.</p> <p>"Someone has a gun in the lobby."</p> <p>Dr. Hendel sprang into action. A Code Silver was called and Incident Command established.</p>`,
    ],
    title: null,
    videos: [],
    audio: [],
  },
  5: {
    checkpoint: false,
    last: false,
    checkpoints: [],
    images: [
      {
        alt: "Press conference",
        image:
          "https://chaplaincy-innovation-lab-lessons.s3.us-east-1.amazonaws.com/2025-01/shutterstock_376505077.jpg",
        order: 0,
      },
    ],
    layoutNumber: 4,
    navigation: [
      { available_scene: "6", current_scene: "5", previous_scene: "4",text: "Continue" },
    ],
    scene_number: "5",
    sidebar: false,
    sidebarImages: [],
    sidebarVideos: [],
    sidebarText: [],
    text: [
      `<p>A few short hours later, Dr. Hendel stood next to the Mayor and Police Chief at a short televised press conference. "It is with a heavy heart that I address you today.” she said somberly. "I'm heartbroken to announce that two members of our employee family have been killed, and another is in critical condition.”</p><p>She took a shallow breath and continued explaining that throughout the entire event, "our first priority was to ensure the safety of our patients - and that they were well cared for.” She continued, "I can assure you that our patients are safe.”</p>

<p>As details emerged, the hospital and public learned that, "A pharmacy technician showed up for work at Long Beach Memorial Medical Center…brandishing two handguns, killed his boss and another manager and then fatally shot himself.” </p><p><strong>This was not a random act as the perpetrator Mario Ramirez sought out and killed Hugo Bustamante and Kelly Hales before turning the gun on himself.</strong></p>`,
    ],
    title: null,
    videos: [],
    audio: [],
  },
  6: {
    checkpoint: false,
    last: false,
    checkpoints: [],
    images: [],
    layoutNumber: 4,
    navigation: [
      { available_scene: "7", current_scene: "6", previous_scene: "5",text: "Continue" },
    ],
    scene_number: "6",
    sidebar: false,
    sidebarImages: [],
    sidebarVideos: [],
    sidebarText: [],
    text: [
      `<p>In the difficult days that followed Dr. Hendel and leaders across the hospital and the healthcare system worked with colleagues in public safety, crisis response, regulatory issues, human resources, and spiritual care to work with the living and the dead.</p><p>In addition to helping the families of those who died navigate post-employment procedures, the chaplains were asked to help plan and conduct onsite memorial services for those who were killed, all three of whom were members of the hospital community. </p>`,
    ],
    title: "The Spiritual Care Team's Responsibilities",
    videos: [],
    audio: [],
  },    
  7: {
    checkpoint: false,
    last: false,
    checkpoints: [],
    images: [],
    layoutNumber: 4,
    navigation: [
      { available_scene: "8", current_scene: "7", previous_scene: "6",text: "Continue" },
    ],
    scene_number: "7",
    sidebar: false,
    sidebarImages: [],
    sidebarVideos: [],
    sidebarText: [],
    text: [
      `<p>In Dr. Hendel's words, "Because we were fortunate to have a large and diverse team of pastors on staff who were experienced in conducting memorial and remembrance services in addition to their usual duties as hospital chaplains, it wasn't uncommon for us to hold services on site when an employee, physician or volunteer passed away. We'd also become accustomed to holding them for board members, community members, and long-time patients whom we'd grown close to and considered part of our organizational family. Sometimes the services were held in addition to a funeral hosted by their family and sometimes they were held in lieu of one. It has become a hallmark of our culture, reflecting our mission for caring for the people in our community at all stages of life, from beginning to end.”</p>

<p>"There was no question that we'd be hosting memorial services for our colleagues - we knew it would be necessary to honor them and collectively grieve as an organization. And even though we had a large auditorium that could accommodate several hundred people, we knew it would be overflowing at each service” (p. 89-90). In addition to colleagues in the hospital, Kelly and Hugo were active in professional associations of pharmacists and the alumni networks of alma maters. 
</p>`,
    ],
    title: "The Spiritual Care Team's Responsibilities",
    videos: [],
    audio: [],
  },    
  8: {
    checkpoint: false,
    last: false,
    checkpoints: [{
      alt: null,
      answer: false,
      content_type: 5,
      data:
        `<ul><li>What went well in this situation? How did the chaplain work with stakeholders to memorialize a complex situation?</li>
        <li>How might race, class, and gender have impacted how decisions were made in this situation?</li>
        <li>How should organizations make decisions about memory in situations like this? For instance, putting the victims’ names on the monument, holding memorial services? Who should be involved in making these decisions? </li>
        </ul>`,
      order: 0,
      question_type: 2,
      scene_number: "8",
      sidebar: false,
    }],
    images: [],
    layoutNumber: 9,
    navigation: [
      { available_scene: "10", current_scene: "7", previous_scene: "6",text: "Continue" },
    ],
    scene_number: "7",
    sidebar: false,
    sidebarImages: [],
    sidebarVideos: [],
    sidebarText: [],
    text: [],
    title: null,
    videos: [],
    audio: [],
  },
  
  10: {
    checkpoint: false,
    last: true,
    checkpoints: [],
    images: [],
    layoutNumber: 6,
    navigation: [{available_scene: "10", current_scene: "10", previous_scene: "7",text: "End Lesson" }],
    scene_number: "10",
    sidebar: false,
    sidebarImages: [],
    sidebarVideos: [],
    sidebarText: [],
    text: [
      `<p>You finished this lesson! You made important decisions about how to deal with violence, trauma, and grief in the workplace. You learned how to balance stakeholder opinions with the needs of those who were most directly affected by violence. These were not easy decisions, and in some instances, there weren't any clear cut answers. </p>`
    ],
    title: "Lesson complete",
    videos: [],
    audio: [],
  },
};

export default lessonData;